/* Clamp the PDP sticky info column's max-height to its real viewport offset.
   The CSS max-height (product.css) assumes the stuck position (top = header + 20px);
   on a freshly opened PDP the column sits lower (below the breadcrumbs), so its
   inner scroll area ended below the fold and the last box could never scroll
   into view until the window scrolled and the column stuck. */
(function () {
  var info = document.querySelector(
    ".product-information.product-information-sticky"
  );
  if (!info) return;

  var mq = window.matchMedia("(min-width: 1068px)");
  var ticking = false;

  function clamp() {
    ticking = false;
    if (!mq.matches) {
      info.style.maxHeight = "";
      return;
    }
    var stickyTop = parseFloat(getComputedStyle(info).top) || 0;
    // Never below the CSS stuck-state offset: when the end of the product grid
    // pushes the column up, rect.top shrinks and an unclamped value would feed
    // back into its own position.
    var top = Math.max(info.getBoundingClientRect().top, stickyTop);
    info.style.maxHeight = window.innerHeight - top + "px";
  }

  function requestClamp() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(clamp);
  }

  clamp();
  window.addEventListener("scroll", requestClamp, { passive: true });
  window.addEventListener("resize", requestClamp);
  window.addEventListener("load", clamp);
})();
